import { useDispatch } from 'react-redux'
import { useLocation, useHistory } from 'react-router-dom'

import { resetUpdatedCustomer } from '~/core/store/app.reducer'

export default function useUpdatedCustomer() {
  const dispatch = useDispatch()
  const location = useLocation()
  const history = useHistory()

  function onUpdateCustomer() {
    dispatch(resetUpdatedCustomer())

    history.push({
      pathname: location.pathname,
      search: `${location.search}&shouldRefresh=true`,
    })
  }

  return {
    onUpdateCustomer,
  }
}
